import { makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
import TaffiLogoRound from '../assets/img/logo_round_white.png';
import TaffiLogoText from '../assets/img/logo_black.png';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const allRelatedStyles = makeStyles({
    main: {
        display: 'flex',
        alignItems: 'center',
        height: '100vh',
        padding: '24px',
        backgroundColor: themes.palette.primary.light,
        flexDirection: 'column',
        overflowY: 'scroll',
        '&Empty': {
            backgroundColor: 'transparent',
        },
    },
    logos: {},
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flex: 1,
        '& h1': {
            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        },
        '& p': {
            fontWeight: 200,
        },
    },
});

function StoreNotApprovedPage() {
    const classes = allRelatedStyles();
    const storeUrl = useSelector((state: RootState) => state.widget.store?.url);

    return (
        <div className={classes.main}>
            <div className={classes.logos}>
                <img src={TaffiLogoRound} alt="" height={40} />
                <img src={TaffiLogoText} alt="" height={40} />
            </div>
            <div className={classes.content}>
                <h1>Store Not Approved!</h1>
                <p>
                    Thank you for trusting Taffi for your styling needs. However, your store{' '}
                    {storeUrl ? new URL(storeUrl)?.hostname : ''} is not yet approved by Taffi. Please contact{' '}
                    <a href="mailto:sales@taffi.co" target="_blank" rel="noreferrer">
                        sales@taffi.co
                    </a>{' '}
                    for further information.{' '}
                </p>
            </div>
        </div>
    );
}

export default StoreNotApprovedPage;
